<!-- App.svelte -->
<script>
	import { onMount, setContext } from 'svelte';
  import { Router, Link, Route } from "svelte-routing";
  import Home from "./Home.svelte";
  import About from "./About.svelte";
	import Innovations from "./Innovations.svelte";
	import Sources from "./Sources.svelte";
	import Tetrad from "./Tetrad.svelte";

	export let url = "";
	
	import { FirebaseApp, Doc, Collection, User, UploadTask, StorageRef } from "sveltefire";
  import firebase from "firebase/app";
  import "firebase/firestore";
  import "firebase/auth";
	const firebaseConfig = {
		apiKey: "AIzaSyC42z5qFaVBhKG06z0DQvBxaSpcQl5b7QU",
		authDomain: "live-tetrad.firebaseapp.com",
		databaseURL: "https://live-tetrad.firebaseio.com",
		projectId: "live-tetrad",
		storageBucket: "live-tetrad.appspot.com",
		messagingSenderId: "634640998736",
		appId: "1:634640998736:web:29c3b0f9d496e217810c55"
	};
	firebase.initializeApp(firebaseConfig);
  const db = firebase.firestore();
  const tetradsRef=db.collection("tetrads")
	
	var temp={
		"uid":"",
		"displayName":"Ray Daly",
		"photoURL":"https://lh3.googleusercontent.com/a-/AOh14Gjp7zISa6pDDYCOm8K09RaMqXkzAlPKShX5Ey4vAA",
		"email":"raydaly@gmail.com",
		"emailVerified":true,
		"phoneNumber":null,
		"isAnonymous":false
		} 

	var provider = new firebase.auth.GoogleAuthProvider();
  function signupGoogle(){
    firebase.auth().signInWithPopup(provider).then(function(result) {
    // This gives you a Google Access Token. You can use it to access the Google API.
    var token = result.credential.accessToken;
    // The signed-in user info.
		var user = result.user;
		userid.set(result.user.uid);
		username.set(result.user.displayName);
		console.log("result.user.displayName: "+result.user.displayName);
		 
    // ...
    }).catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      // ...
    });
	}
	
	// all editions of McLuhan's books
	// https://monoskop.org/Marshall_McLuhan?fbclid=IwAR1qojgOhiCS04MM5pi6J2CiaqLglrdynl9wFDUrUI3aD7tOGVO-tZYiMfI
	
</script>



<FirebaseApp {firebase}>
	<Router url="{url}">
		<header>
			<div>&nbsp;</div>
			<div class="title">Tetrad Live!</div>
			<div class="auth">
				<!-- user log in and log out-->
				<User let:user let:auth>
					<!-- {JSON.stringify(user)} -->
					<button on:click={() => auth.signOut()}>Sign Out</button>
					{#if user.displayName}
						<img width="33px" height="33px" alt="photo of {user.displayName}" src="{user.photoURL}">
						<span class="displayName">{user.displayName}</span>
					{:else}
						<span class="displayName">{user.uid}</span>
					{/if}
					<div slot="signed-out" class="signed-out">
						<button on:click={() => signupGoogle()}>
							Google Sign In
						</button>
					</div>
				</User>
			</div>
		</header>
		<nav>
			<!-- <Link to="/">Home</Link> -->
			<Link to="about">About Tetrad Live!</Link>
			<span>&nbsp;&nbsp;&mdash;&nbsp;&nbsp;</span>
			<Link to="innovations">Innovations</Link>
			<span>&nbsp;&nbsp;&mdash;&nbsp;&nbsp;</span>
			<Link to="sources">Sources</Link>
		</nav>
		<div>
			<Route path="tetrad/:tetradId" let:params>
				<Tetrad tetradId="{params.tetradId}" />
			</Route>
			<Route path="innovations" component="{Innovations}" />
			<Route path="about" component="{About}" />
			<Route path="home" component="{Home}" />
			<Route path="sources" component="{Sources}" />
			<Route path="/"><About /></Route>
		</div>
	</Router>

</FirebaseApp>

<style>
	header {display: grid; grid-template-columns: 2fr 1fr 2fr}
	.title {text-align: center; font-size: 1.4rem;}
	.auth {min-width: 10rem; text-align: right;}
	.auth img {vertical-align: middle;  padding-left: 1rem; margin-right: -0.5rem;}
	.displayName {padding: 0.5rem;}
	nav {font-size: 1.5rem; font-weight: bold; 
		border-bottom-color: grey; border-bottom-style: solid; border-bottom-width: 2px;}
</style>

